import React from 'react';
import { Link } from 'react-router-dom';
import './NewsCard.css';
import clockIcon from '../../assets/icons/clock.svg';

const NewsCard = ({ id, title, description, image, date, className = '' }) => {
  return (
    <Link to={`/news/${id}`} className={`news-page-card-link ${className}`}>
      <div className="news-page-card">
        <div className="news-page-card-image">
          <img src={image} alt={title} />
        </div>
        
        <div className="news-page-card-title">{title}</div>
        
        <p className="news-page-card-description">{description}</p>
        
        <div className="news-page-card-date-wrapper">
          <img src={clockIcon} alt="Время" className="news-page-card-clock" />
          <div className="news-page-card-date">{date}</div>
        </div>
        
        <button className="news-page-card-button">
          <div className="news-page-card-button-shadow"></div>
          <div className="news-page-card-button-main">
            <span className="news-page-card-button-text">Подробнее</span>
          </div>
        </button>
      </div>
    </Link>
  );
};

export default NewsCard;